



















































































































































































































import { Component, Prop, Vue, Watch, PropSync } from "vue-property-decorator";
import _ from "lodash";
import { DxButton } from "devextreme-vue/ui/button";
import DSelectbox from "@/components/DSelectbox/selectbox.vue";
import { DxPopup } from "devextreme-vue";
import DTextbox from "@/components/DTextbox/textbox.vue";
import DTagbox from "@/components/DTagbox/tagbox.vue";
import DNumberbox from "@/components/DNumberbox/numberbox.vue";
import DxScrollView from 'devextreme-vue/scroll-view';
import { DxCheckBox } from "devextreme-vue/check-box";
import { CutType, CutWithAccept, TariffHistoryType } from "@/services/models-service";
import { type_cut } from "@/constants";
import { YearType, FacilityType } from "@/services/models-service";
import YearService from "@/services/years-service";
import TariffService from "@/services/tariff-service";
import TariffHistoryService from "@/services/tariff-history-service";
import FilialService, { Filial } from "@/services/data/filial_service";
import FacilityService from "@/services/data/facility_service";
import { confirm } from "devextreme/ui/dialog";
import {view_tarif, sign_internal_turnover, value_group, value_group_vgo, periods, months} from "@/constants";
import {HeatCarrier} from "@/services/data/heat_carrier_service";
import DictCacheService from "@/services/dicts_cache_service";

@Component({
  name: "TariffHistoryDetailPopup",
  components: {
    DxButton,
    DSelectbox,
    DxPopup,
    DTextbox,
    DxCheckBox,
    DTagbox,
    DNumberbox,
    DxScrollView
  }
})
export default class extends Vue {
  @PropSync('popupOptions') public localPopupOptions: any;

  public all_years: YearType[] = [];

  private localTypeCut = type_cut;

  private allFilial: Filial[] = [];
  private allFacility: FacilityType [] = [];
  public warmEnergyArray: any[] = [];

  private cutsBusiness: CutType [] = [];
  private cutsFacts: CutType [] = [];
  private current_cuts: CutType [] = [];
  public allHeatCarrier: HeatCarrier[] = [];
  private log_content: any = {};
  private log_current: TariffHistoryType | null = null;

  public service = TariffHistoryService;
  public value_group = value_group;
  public value_group_vgo = value_group_vgo;
  public sign_internal_turnover = sign_internal_turnover;
  public view_tarif = view_tarif;
  public months = months;


  async created() {
    let indx = 0;
    // шаблон {tariff: "january_we", index: "index_january_we", order: 0, tariff_wp: "january_wp", index_wp: "index_january_wp"},
    for (let p of periods) {
      this.warmEnergyArray.push({
        order: indx,
        tariff: `${p}_we`,
        index: `index_${p}_we`,
        tariff_wp: `${p}_wp`,
        index_wp: `index_${p}_wp`
      });
      indx++;
    }

    this.allHeatCarrier = DictCacheService.heat_carrier;
    this.all_years = YearService.YearList;
    this.log_current = _.cloneDeep(this.service.current);
    this.log_content = _.cloneDeep(this.service.current?.content);
    
  }

  get title() {
    return this.log_current?.crud_type === 1 ? 'Лог создания тарифа'
      : (this.log_current?.crud_type === 2 ? 'Лог редактирования тарифа' : 'Лог удаления тарифа')
  }

  async mounted() {

  }

  isChanged(field_name: string) {
    return this.log_content.old.hasOwnProperty(field_name);
  }

  oldValue(field_name: string) {
    if (this.isChanged(field_name)) {
      return `Прежнее значение: ${this.log_content.old[field_name]}`;

    }
  }

  async onShowing() {


  }

  onShow() {

  }



  onClose() {

      this.localPopupOptions.visible = false;
  }

}
